import React from "react"
import styled from "styled-components"
import { Row, Spin } from "antd"
import AdvantagesSection from "../components/home-page/advantages-section"
import BlogsSection from "../components/home-page/blogs-section"
import CallUs from "../components/home-page/call-us-section"
import ServicesSection from "../components/home-page/services-section"
import ProductsSection from "../components/home-page/products-section"
import HeroSection from "../components/home-page/hero-section"
import HowItWorks from "../components/home-page/how-it-works"
import Navbar from "../components/common/navbar/Navbar"
import Topbar from "../components/common/navbar/topbar"
import useProducts from "../utils/useProducts"
import useNavbar from "../utils/useNavbar"
import useHomePage from "../utils/useHomePage"

const StyledDiv = styled.div`
  background-image: url(${props => props.url});
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100%;
  overflow: hidden;
`
const Spinner = styled.div`
  .ant-spin-spinning {
    margin: 8rem;
    overflow: hidden;
    padding: 2rem;
  }
`
const IndexPage = () => {
  const { navLinks } = useNavbar()
  const { homeData } = useHomePage()
  const { products, loading } = useProducts()

  return (
    <>
      {loading ? (
        <Row justify="center">
          <Spinner>
            <Spin size="large" />
          </Spinner>
        </Row>
      ) : (
        <>
          <StyledDiv
            url={
              homeData.acf.slider_image ? homeData.acf.slider_image.url : null
            }
          >
            <Topbar />
            <Navbar navLinks={navLinks} />
            <HeroSection data={homeData} />
          </StyledDiv>

          <ServicesSection />
          <HowItWorks data={homeData} />
          <ProductsSection products={products} />
          <AdvantagesSection />
          <BlogsSection />
          <CallUs data={homeData} />
        </>
      )}
    </>
  )
}

export default IndexPage
